import { useAtom } from 'jotai';
import { editChildMutationAtom } from '@/features/profile/MinorChildren/state/editChildMutationAtom';

// Custom hook to add a child
export const useEditChild = () => {
    const [{ mutate, status, reset, error }] = useAtom(editChildMutationAtom); // `useAtom` to access the mutation state and trigger function

    // Return the mutation state and trigger function
    return {
        mutate, // This will trigger the mutation
        status,
        reset,
        errorMessage: error instanceof Error ? error.message : null,
    };
};
